export const getStyles = () => ({
  statisticsSection: {
    paddingBlock: "24px",

    "& h2": {
      gridColumn: "1 / -1",
      textAlign: "center",
      fontWeight: 700,
      fontSize: "1.25rem",
      marginBottom: "24px",
    },

    "@media (min-width: 960px)": {
      gridColumn: "2 / -2",
      paddingBlock: "72px",

      "& h2": {
        fontSize: "2.5rem",
        marginBottom: "72px",
      },
    },
  },
  statisticsContent: {
    gridColumn: "2 / -2",
    display: "grid",
    gap: "24px",

    paddingInline: "40px",
    "@media (min-width: 960px)": {
      gridTemplateColumns: "1fr 1fr 1fr",
      gap: "54px",
      paddingInline: 0,
    },
  },
  statisticsItem: {
    textAlign: "center",

    "& h3": {
      fontSize: "1.25rem",
      fontWeight: 600,
    },
    "& p": {
      fontSize: "0.875rem",
    },

    "@media (min-width: 960px)": {
      "& h3": {
        fontSize: "2rem",
      },
      "& p": {
        fontSize: "1.5rem",
      },
    },
  },
});
